import React from "react";

const TickIcon   = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
    <mask id="mask0_2841_13156" style={{maskType: "alpha"}} maskUnits="userSpaceOnUse" x="0" y="0" width="18" height="18">
      <rect width="18" height="18" fill="#D9D9D9"/>
    </mask>
    <g mask="url(#mask0_2841_13156)">
      <path d="M7.16172 13.5002L2.88672 9.2252L3.95547 8.15645L7.16172 11.3627L14.043 4.48145L15.1117 5.5502L7.16172 13.5002Z" fill="#C78D3C"/>
    </g>
  </svg>
);

export default TickIcon  ;

